import React, { useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import API from "../../../services/api";

import "./OTPVerification.css";

function OTPVerification() {

    const { orderId } = useParams();

    const navigate = useNavigate();

    const [otp, setOtp] = useState("");

    const [loading, setLoading] = useState(false);
const verifyOTP = async () => {

    if (otp.length !== 6) {

        alert("Enter valid OTP");

        return;

    }

    try {

        setLoading(true);

        console.log("🔐 Verifying delivery OTP...");
        console.log("Order ID:", orderId);
        console.log("OTP:", otp);


        // =====================================================
        // STEP 1: VERIFY CUSTOMER OTP
        // =====================================================

        const response = await API.put(
            `/delivery/orders/${orderId}/verify-otp`,
            {
                otp,
            }
        );


        console.log(
            "✅ OTP Verification Response:",
            response.data
        );


        if (!response.data?.success) {

            throw new Error(
                response.data?.message ||
                "OTP verification failed."
            );

        }


        // =====================================================
        // STEP 2: COMPLETE DELIVERY
        // =====================================================

        console.log(
            "🚚 Completing delivery..."
        );


        const completeResponse = await API.put(
            `/delivery/orders/${orderId}/complete`
        );


        console.log(
            "✅ Complete Delivery Response:",
            completeResponse.data
        );


        if (!completeResponse.data?.success) {

            throw new Error(
                completeResponse.data?.message ||
                "Delivery could not be completed."
            );

        }


        // =====================================================
        // SUCCESS
        // =====================================================

        alert(
            "🎉 Delivery Completed Successfully"
        );


        console.log(
            "🏠 Navigating to Delivery Home..."
        );


        navigate(
            "/delivery/home",
            {
                replace: true,
            }
        );


    } catch (error) {

        console.error(
            "❌ Delivery Verification Error:",
            error.response?.data ||
            error
        );


        alert(

            error.response?.data?.message ||

            error.message ||

            "Failed to complete delivery."

        );

    } finally {

        setLoading(false);

    }

};

    return (

        <div className="otp-page">

            <div className="otp-card">

                <h1>

                    Verify Delivery

                </h1>

                <p>

                    Enter the OTP provided by the customer.

                </p>

                <input

                    type="text"

                    maxLength="6"

                    value={otp}

                    onChange={(e)=>

                        setOtp(

                            e.target.value.replace(

                                /\D/g,

                                ""

                            )

                        )

                    }

                    placeholder="----"

                />

                <button

                    onClick={verifyOTP}

                    disabled={loading}

                >

                    {

                        loading

                        ?

                        "Verifying..."

                        :

                        "Verify OTP"

                    }

                </button>

            </div>

        </div>

    );

}

export default OTPVerification;